import request from '@/utils/ajax';

export const strategyArticleContentTypes = Object.freeze([
  { value: 1, name: '纯文本' },
  { value: 2, name: '图片' },
  { value: 3, name: '图文' },
  { value: 4, name: '视频' },
  { value: 5, name: '视频+文本' },
  { value: 6, name: '文件' }
]);

const contentFieldByType = {
  1: 'contentText',
  2: 'contentImg',
  3: 'contentEdit',
  4: 'contentVideo'
};

function stringValue(value) {
  return value == null ? '' : String(value);
}

function escapeHtmlAttribute(value) {
  return stringValue(value)
    .replace(/&/g, '&amp;')
    .replace(/'/g, '&#39;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}

function unescapeHtmlAttribute(value) {
  return stringValue(value)
    .replace(/&#0*39;/gi, "'")
    .replace(/&quot;/gi, '"')
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>')
    .replace(/&amp;/gi, '&');
}

function buildMediaContent(tag, url, text) {
  return `<p><${tag} src='${escapeHtmlAttribute(url)}'/></p>${stringValue(text)}`;
}

function parseMediaContent(tag, content, urlField, textField) {
  const source = stringValue(content);
  const marker = new RegExp(`^<p><${tag}\\s+src=(['"])([\\s\\S]*?)\\1\\s*\\/?></p>`, 'i');
  const match = source.match(marker);
  return {
    [urlField]: match ? unescapeHtmlAttribute(match[2]) : '',
    [textField]: match ? source.slice(match[0].length) : source
  };
}

export function getStrategyArticleContentTypeName(contentType) {
  const type = strategyArticleContentTypes.find(item => item.value === contentType);
  return type ? type.name : '未知类型';
}

export function buildStrategyArticleContent(form) {
  const field = contentFieldByType[form.contentType];
  if (field) {
    return stringValue(form[field]);
  }
  if (form.contentType === 5) {
    return buildMediaContent('video', form.contentVideoTextUrl, form.contentVideoText);
  }
  if (form.contentType === 6) {
    return buildMediaContent('file', form.contentFileUrl, form.contentFileText);
  }
  return '';
}

export function parseStrategyArticleContent(contentType, content) {
  const field = contentFieldByType[contentType];
  if (field) {
    return { [field]: stringValue(content) };
  }
  if (contentType === 5) {
    return parseMediaContent('video', content, 'contentVideoTextUrl', 'contentVideoText');
  }
  if (contentType === 6) {
    return parseMediaContent('file', content, 'contentFileUrl', 'contentFileText');
  }
  return {};
}

export function addOss(data){
  return request({
    url: `/wx/manage/forwardStrategy/list`,
    method: 'get',
    params: data
  });
}

export function queryTypeList(data){
  return request({
    url: `/wx/manage/forwardStrategy/list`,
    method: 'get',
    params: data
  });
}

export function saveArticle(data){
  return request({
    url: `/wx/manage/spiderArticle/save`,
    method: 'post',
    data: data
  });
}

export function updateArticle(data){
  return request({
    url: `/wx/manage/spiderArticle/update`,
    method: 'put',
    data: data
  });
}

export function deleteArticle(data){
  return request({
    url: `/wx/manage/spiderArticle/delete`,
    method: 'post',
    data: data
  });
}



export function rulesList(data){
  return request({
    url: `wx/manage/spiderArticlePublish/list`,
    method: 'get',
    params: data
  });
}
